// Generated by ReScript, PLEASE EDIT WITH CARE

import * as PlaceOrderContext from "./PlaceOrderContext.bs.js";

var make = PlaceOrderContext.context.Provider;

function makeProps(value, children, param) {
  return {
          value: value,
          children: children
        };
}

export {
  make ,
  makeProps ,
  
}
/* make Not a pure module */
